import store from '@/store/index'
import moment from 'moment/src/moment'

class TrackerModule {
  monthView = {
    get() {
      return store.state.monthView
    },
    set(visible) {
      store.commit('SET_MONTH_VIEW', visible)
    }
  }

  selectedMonth = {
    get() {
      return store.state.selectedMonth
    },
    set(month) {
      store.commit('SET_SELECTED_MONTH', month)
    }
  }

  selectedMonthName = {
    get() {
      return store.state.selectedMonthName
    },
    set(monthName) {
      store.commit('SET_SELECTED_MONTH_NAME', monthName)
    }
  }

  selectedYear = {
    get() {
      return store.state.selectedYear
    },
    set(year) {
      store.commit('SET_SELECTED_YEAR', year)
    }
  }

  initMonths() {
    const months = []
    let currentMonth = 11
    if (store.state.selectedYear === moment().year()) {
      currentMonth = moment().month()
    }

    let selectedMonthExists = false
    for (let i = currentMonth; i >= 0; i--) {
      const month = moment()
        .month(i)
        .format('MMMM')
      months.push(month)
      if (selectedMonthExists) continue
      selectedMonthExists = month === store.state.selectedMonthName
    }

    if (!selectedMonthExists) {
      store.commit('SET_SELECTED_MONTH_NAME', months[0])
      store.commit('SET_SELECTED_MONTH', currentMonth)
    }

    return months
  }

  initYears(habit, isNewHabit) {
    const years = []
    const year = moment().year()
    for (let i = year; i >= habit.yearCreated; i--) {
      years.push(i)
    }
    if (isNewHabit) store.commit('SET_SELECTED_YEAR', year)

    return years
  }
}

export default new TrackerModule()
